import { useEffect, useState } from "react";
import { connect } from "react-redux";
import ReactSelect from "react-select";

import { camelCase } from "lodash";
import { DisconnectButton, IntegrationConnectionHandler } from "../IntegrationComponents";
import { IntegrationImportSchemes, IntegrationOnGoingPolls } from "./PensionIntegrationComponents";
import { Actions as PENSION_INTEGRATION_ACTIONS } from "./store/pensionIntegrationActions";

const PensionIntegrationSettings = ({
	logo,
	integration,
	// connected = true,
	connected,
	status,
	connect,
	verifyConnection,
	disconnect,
	save,
	settings,
	disabled,
	importSchemes,
	importingSchemes,
	pensionPayScheduleOptions,
	paySchedules,
	saving,
	getOngoingPolls,
	closePollModal,
	pollActionModal,
	handlePollAction,
	onGoingPolls,
	functionality,
	statusMessages,
	currency,
	companyPayPeriods,
	isComingSoon,
	getSchemes,
}) => {
	const [expand, setExpand] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const [data, setData] = useState({});

	useEffect(() => {
		if (!connected && expand) setExpand(false);
	}, [connected, expand]);

	useEffect(() => {
		setData(settings || {});
	}, [JSON.stringify(settings)]);

	const updateSetting = ({ category, field, value }) => {
		setData({
			...data,
			[category]: {
				...data?.[category],
				[field]: value,
			},
		});
	};
	// used to mark expanded so we fetch company and accounts data once
	useEffect(() => {
		if (!expanded && expand) {
			setExpanded(true);
		}
	}, [expand]);

	// TODO get information on whether this integration supports multi-company and multi-accounts to avoid these requests
	// fetches all companies linked with this pension integration
	// useEffect(() => {
	// 	if (expanded && !settings?.companies) {
	// 		getCompanies(integration);
	// 	}
	// }, [integration, expanded]);

	return (
		<div className={`${expand ? "tr-gray " : ""} col-xs-12 integration-row`}>
			<div className="col-xs-3">
				<img
					src={logo}
					width="40px"
					alt={`${integration} logo`}
				/>
				<span style={{ paddingLeft: 20, fontSize: 16 }}>{integration}</span>
			</div>
			<div className="col-xs-9">
				<IntegrationConnectionHandler
					functionality={functionality}
					connected={connected}
					isComingSoon={isComingSoon}
					status={status}
					connect={connect}
					statusMessages={statusMessages}
					verifyConnection={verifyConnection}
					disconnect={disconnect}
					setExpand={() => setExpand(!expand)}
					expand={expand}
				/>
			</div>
			<div className="clearfix" />
			{expand && connected ? (
				<>
					<div className="px-6">
						<div className="col-xs-3 pl-0 mt-4"></div>
						<div className="col-xs-9 px-0 pt-3 flex justify-end items-start">
							<IntegrationImportSchemes
								functionality={functionality}
								importSchemes={importSchemes}
								importingSchemes={importingSchemes}
								getSchemes={getSchemes}
							/>
							<DisconnectButton
								connected={connected}
								disconnect={disconnect}
							/>
						</div>
					</div>
					<div className="clearfix" />
					<div className="px-6">
						<IntegrationOnGoingPolls
							onGoingPolls={onGoingPolls}
							currency={currency}
							getOngoingPolls={getOngoingPolls}
							functionality={functionality}
							pollInteraction={handlePollAction}
							closeModal={closePollModal}
							modalStatus={pollActionModal}
							companyPayPeriods={companyPayPeriods}
						/>
					</div>
					<div className="flex justify-between align-top px-6">
						{pensionPayScheduleOptions?.length ? (
							<>
								<div className="form-inner-section px-0 mx-0">
									<div
										className="form-section-header"
										style={{ marginLeft: "1.5rem", marginBottom: "2rem" }}
									>
										<h4>Pay Schedule Settings</h4>
									</div>
									{pensionPayScheduleOptions?.map((option) => {
										return (
											<>
												<div className="col-xs-6">
													<div
														className="form-material"
														style={{ marginBottom: "2rem" }}
													>
														<label htmlFor="material-text">{integration}</label>
														<ReactSelect
															value={option}
															isDisabled={true}
														/>
													</div>
												</div>
												<div className="col-xs-6">
													<div
														className="form-material"
														style={{ marginBottom: "2rem" }}
													>
														<label htmlFor="material-text">Buddy</label>
														<ReactSelect
															options={paySchedules}
															value={paySchedules?.find(
																({ value }) =>
																	value == settings?.paySchedules?.[option?.value],
															)}
															isDisabled={disabled}
															onChange={(selected) => {
																updateSetting({
																	category: "paySchedules",
																	field: option?.value,
																	value: selected?.value,
																});
															}}
														/>
													</div>
												</div>
											</>
										);
									})}
									<button
										style={{ marginRight: "2rem" }}
										className="btn btn-success pull-right"
										onClick={() => {
											console.debug("save", data);
											save(data);
										}}
										disabled={saving}
									>
										Save
									</button>
									<div className="clearfix" />
								</div>
							</>
						) : null}
					</div>
				</>
			) : null}
		</div>
	);

	// TODO add expandable options for selecting a Company and an Account
};

const mapStateToProps = (state, ownProps) => {
	const { integration } = ownProps;

	const settings = state?.integration?.pension?.[camelCase(integration)];
	const { functionality, logo, isComingSoon } = state?.integrationDetails?.pension?.[camelCase(integration)] || {};

	const companyPayPeriods = state.payPeriods?.periods?.map((period) => {
		const paySchedule = state.company?.settings?.paySchedules?.find(
			(schedule) => schedule.id == period.paySchedule,
		);

		return {
			...period,
			name: `${paySchedule?.name} ${period.period} ${period.year}`
		};
	});

	return {
		companyPayPeriods,
		connected: !!settings,
		functionality,
		logo,
		isComingSoon,
		pollActionModal: settings?.pollActionModal,
		settings,
		currency: state?.company?.settings?.currency,
		status: settings?.status,
		statusMessages: settings?.statusMessages,
		onGoingPolls: settings?.onGoingPolls,
	};
};

const mapDispatchToProps = (dispatch, { integration }) => ({
	importSchemes: () => dispatch(PENSION_INTEGRATION_ACTIONS.importSchemes(integration)),
	getSchemes: (query) => dispatch(PENSION_INTEGRATION_ACTIONS.getSchemes(integration, query)),
	connect: (credentials) => dispatch(PENSION_INTEGRATION_ACTIONS.connectPensionIntegration(integration, credentials)),
	disconnect: () => dispatch(PENSION_INTEGRATION_ACTIONS.disconnectPensionIntegration(integration)),
	verifyConnection: () => dispatch(PENSION_INTEGRATION_ACTIONS.verifyConnection(integration)),
	getOngoingPolls: () => dispatch(PENSION_INTEGRATION_ACTIONS.getOngoingPolls(integration)),
	handlePollAction: (pollId, action, status) =>
		dispatch(PENSION_INTEGRATION_ACTIONS.handlePollAction({ integration, pollId, action, status })),
	closePollModal: () => dispatch(PENSION_INTEGRATION_ACTIONS.openPollActionModal(integration, false)),
	save: () => dispatch(PENSION_INTEGRATION_ACTIONS.save(integration)),
	updateField: (field, value) => dispatch(PENSION_INTEGRATION_ACTIONS.updateField(integration, field, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PensionIntegrationSettings);
